const Panel = function panel(name, container, options = null) {

    if (container) container.classList.remove('nojs');

    const settings = {
        name: name,
        container: container,
        panel: undefined,
        closeBtns: undefined,
        openBtns: undefined,
        trap: undefined,
        onopen: undefined,
        onclose: undefined,
        instance: undefined,
        onready: undefined,
        dismissible: true,
        unobstrusive: false,
        initialFocus: undefined,
        get fallbackFocus() {
            return panelInstance.el.panel.querySelector('[data-panel-content]');
        },
        get focusTrapConfig() {
            return {
                initialFocus: settings.initialFocus,
                fallbackFocus: settings.fallbackFocus,
                escapeDeactivates: () => {
                    if (settings.dismissible) panelInstance.close();
                    return false;
                },
                clickOutsideDeactivates: () => {
                    if (settings.dismissible) panelInstance.close();
                    return false;
                }
            }
        }
    };
    const focusTrapSettings = {
        get initialFocus() { return settings.initialFocus },
        get fallbackFocus() { return settings.fallbackFocus },
        get escapeDeactivates() {
            if (settings.dismissible) panelInstance.close();
            return false;
        },
        get clickOutsideDeactivates() {
            if (settings.dismissible) panelInstance.close();
            return false;
        }
    };
    const self = this;
    const ext = {
        get settings() { return settings; },
        get instance() { return panelInstance; },
        el: {
            get container() {
                return settings.container
            },
            get panel() {
                return settings.panel
            }
        },
        registerCallback(evnt, instance, func) {
            settings.instance = panelInstance;
            settings[evnt] = func;
        },
        registerOnOpenCallback(instance, func) {
            ext.registerCallback("onopen", instance, func)
        },
        registerOnCloseCallback(instance, func) {
            ext.registerCallback("onclose", instance, func)
        },
        registerOnReadyCallback(instance, func) {
            ext.registerCallback("onready", instance, func)
        }
    };

    const status = {
        open: false
    };
    const isOpen = () => {
        return settings.panel.classList.contains('active');
    };


    const init = (name, container, _this)=> {
        settings.container = container;
        settings.panel = container.querySelector('.panel');
        settings.closeBtns = container.querySelectorAll('[data-panel-close]');
        settings.openBtns = document.querySelectorAll(`[data-panel-open="${name}"]`);
        settings.openBtns.forEach(b => {
            b.removeEventListener('click', handleOpen);
            b.addEventListener('click', handleOpen.bind(panelInstance));
        });
        settings.initialFocus = settings.initialFocus || panelInstance.el.panel.querySelector('[data-panel-content]');
        if (container.dataset.dismissible == "false") settings.dismissible = false;
        //settings.trap = focusTrap.createFocusTrap(settings.container, {
        //    initialFocus: settings.initialFocus,
        //    escapeDeactivates: () => {
        //        if (settings.dismissible) close();
        //        return false;
        //    },
        //    clickOutsideDeactivates: () => {
        //        if (settings.dismissible) close();
        //        return false;
        //    }
        //});
        settings.trap = focusTrap.createFocusTrap(settings.container, settings.focusTrapConfig );
        if (typeof (settings.onready) == "function") {
            ext.registerOnReadyCallback(panelInstance, settings.onready);
        }
        if (typeof (settings.onopen) == "function") {
            ext.registerOnOpenCallback(panelInstance, settings.onopen);
        }
        if (typeof (settings.onclose) == "function") {
            ext.registerOnCloseCallback(panelInstance, settings.onclose);
        }
        return _this;
    }
    const open = (replacing = false) => {
        const historyHasState = history.state && history.state.modalOpen && history.state.modelName == settings.name;
        windowTop = window.scrollY;

        if (!settings.unobstrusive) {
            document.querySelector('html').style.setProperty("--body-top", -windowTop + "px")
            document.body.classList.add('no-scroll');
            //settings.trap.activate();
        }
        if (typeof (settings.onopen) == "function") {
            settings.onopen(panelInstance);
        }
        settings.container.classList.add('active');
        settings.panel.classList.add('active');
        addEventListeners(this);

        if (!settings.unobstrusive) {
            settings.trap.activate();
        }
        if (replacing) {
            history.replaceState({ modalOpen: true, modelName: settings.name }, 'Modal open', '#' + settings.panel.id);
        }
        if (!historyHasState) {
            history.pushState({ modalOpen: true, modelName: settings.name }, 'Modal open', '#' + settings.panel.id);
        }
        status.open = true;
    };
    const close = (replaced = false) => {
        settings.container.classList.remove('active');
        settings.panel.classList.remove('active');
        removeEventListeners();
        if (!settings.unobstrusive) {
            document.body.classList.remove('no-scroll');
            document.querySelector('html').style.scrollBehavior = "auto"
            window.scrollTo(0, windowTop);
        }
        if (typeof (settings.onclose) == "function") {
            settings.onclose(panelInstance);
        }
        if (!settings.unobstrusive) {
            settings.trap.deactivate();
            document.querySelector('html').style.scrollBehavior = "smooth"
        }
        if (replaced) {
            status.open = false;
        }
        else if (history.state && history.state.modalOpen && history.state.modelName == settings.name) {
            history.back();  // This removes the modal from the history stack
        }
    };
    const handleOpen = (e) => {
        e.preventDefault();
        open();
    };
    const handleClose = (e) => {
        e.preventDefault();
        close();
    };
    const handleContainerClick = (e) => {
        if (e.target.matches('[data-panel-overlay]')) {
            e.preventDefault();
            if (settings.dismissible) close();
        }
    };

    const addEventListeners = (_this) => {
        //const _this = this;
        settings.closeBtns.forEach(b => {
            b.addEventListener('click', handleClose);
        });
        settings.container.addEventListener('click', handleContainerClick);

    };
    const removeEventListeners = () => {
        settings.closeBtns.forEach(b => {
            b.removeEventListener('click', handleClose);
        })
        settings.container.removeEventListener('click', handleClose);
    };

    const create = (instance, options = null) => {
        if (options != null) {
            Object.entries(options).forEach(([key, val]) => {
                //console.log(`${key}:${val}`);
                if (settings.hasOwnProperty(key)) {
                    if (settings[key] != val) {
                        Reflect.set(settings, key, val);
                    }
                }
            });
        }
        init(name, container, instance);
        if (typeof (settings.onready) == "function") {
            settings.onready(panelInstance);
        }
    };

    //const _this = init(name, container);
   
    const panelInstance = {
        openHandler: handleOpen,
        closeHandler: handleClose,
        open: open,
        close: close,
        onopen: ext.registerOnOpenCallback,
        onclose: ext.registerOnCloseCallback,
        onready: ext.registerOnReadyCallback,
        registerCallback: ext.registerCallback,
        init: create,
        el: ext.el,
        settings: ext.settings,
        get isOpen() { return isOpen }
    };
    create(panel, options);

    const logPopstate = (state, modelName) => {
        if (state != null) {
            console.log('========================');
            console.log('popstate');
            console.log('name: ' + settings.name);
            console.log('state.modelName: ' + modelName);
            console.log('isOpen: ' + status.open);
            console.log('------------------------');
        }

    };
    // Handle back button navigation (or forward)
    const handlePopstate = (event) => {
        var modelName = event.state != null ? event.state.modelName : '';
        logPopstate(event.state, modelName);

        //const shouldOpen = isOpen() != true;
        const shouldOpen = status.open == false;
        if (event.state && event.state.modelName != settings.name) {
            return;
        }
        if (event.state && event.state.modalOpen && event.state.modelName == settings.name) {
            if (shouldOpen) {
                // If the state is related to the modal being open, show the modal
                open();
            }
            else {
                close();
                status.open = false;
            }
        } else if (status.open) {
            // If no modal-related state, ensure it's closed
            close();
            status.open = false;
        }

    }
    const addHistoryListener = () => {
        window.addEventListener("popstate", handlePopstate);
    }
    const removeHistoryListener = () => {
        window.removeEventListener("popstate", handlePopstate);
    }

    settings.instance = panelInstance;
    addHistoryListener();

    return panelInstance;
}
if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
}
function PanelEnquiryObject(containerElement) {
    const
        container = containerElement.querySelector('.enquiry-object'),
        view = {
            img: {
                data: '',
                get elem() { return container.querySelector('.enquiry-object-img') },
                update: function (val) { data = val; this.elem.src = data; }
            },
            name: {
                data: '',
                get elem() { return container.querySelector('.enquiry-object-name') },
                update: function (val) { data = val; this.elem.textContent = data; }
            },
            description: {
                data: '',
                get elem() { return container.querySelector('.enquiry-object-desc') },
                update: function (val) { data = val; this.elem.textContent = data; }
            },
            value: {
                data: '',
                get elem() { return container.querySelector('.enquiry-object-value') },
                update: function (val) { data = val; this.elem.innerHTML = data; }
            }
        },
        update = function (updateData) {
            Object.entries(updateData).forEach(([key, value]) => { if (key in view) view[key].update(value) });
        };

    return { update: update };
        
}